import styled from 'styled-components';

import { StatusBanner } from '@xingternal/banner';
import { Button } from '@xingternal/button';
import { mediaConfined } from '@xingternal/layout-tokens';
import { spaceL } from '@xingternal/tokens';

export const UpdateProfileCta = styled(Button)`
  width: 100%;

  @media ${mediaConfined} {
    width: 60%;
  }
`;

export const BannerWrapper = styled.div`
  width: 100%;

  @media ${mediaConfined} {
    width: 60%;
  }
`;

export const Banner = styled(StatusBanner)`
  margin-top: ${spaceL};
`;
